// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from 'firebase/firestore';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAh2Z0cRa0XIPOGHulFuWf2eqa99As7H0Y",
  authDomain: "test-firestore-875da.firebaseapp.com",
  projectId: "test-firestore-875da",
  storageBucket: "test-firestore-875da.appspot.com",
  messagingSenderId: "1020940176316",
  appId: "1:1020940176316:web:3a3054b8ae3e75289279b9",
  measurementId: "G-3J1SJJ7SRC"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
// eslint-disable-next-line no-unused-vars
const analytics = getAnalytics(app);
console.log(analytics);

//const app = firebase.initializeApp(firebaseConfig);

const db = getFirestore();
export { db };